var map = {
	"./symbol_0.png": 18046,
	"./symbol_1.png": 5735,
	"./symbol_2.png": 37260,
	"./symbol_3.png": 3797,
	"./symbol_4.png": 45850,
	"./symbol_5.png": 67427,
	"./symbol_6.png": 14216,
	"./symbol_7.png": 70513,
	"./symbol_8.png": 42678
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 81001;